import {
  getOrder,
  updateOrderAddress,
  updateGiftCard,
  updateOrderStatus,
  updateShipping,
  getInvoices,
  addInvoice,
  deleteInvoice,
  updateAll,
  getCRMNotes,
  getCRMNote,
  getExtraOrderInfo,
  addNote,
  updateNote,
} from "../../../api/divvy-customerOrders-orderDetails";
import { UTCToLocale, localeToUTC } from "@/utilities/date.js";

const orderDetails = {
  namespaced: true,
  state: {
    LoadingForStatus: false,
    new_title: "",
    openNote_Loading: false,
    new_note: false,
    orderData: [
      {
        clientCurrencyLabel: "",
        userId: null,
        userName: "",
        points: null,
        userFirstname: "",
        userLastname: "",
        userAddress1: "",
        userAddress2: "",
        userCity: "",
        userState: "",
        userZip: "",
        singleitem: false,
        singleordered: false,
        userdayphone: "",
        usereveningphone: "",
        orderId: null,
        user_id: null,
        orderNumber: "",
        billingCode: "",
        orderDate: "",
        gift: false,
        coname: "",
        masterStatus: "",
        dateHandled: "",
        status: "",
        callTag: false,
        nla: false,
        labelReq: false,
        labelReqDate: null,
        amazonProduct: null,
        replaceReq: false,
        ret_points: false,
        ret_by: null,
        ret_reason: "",
        backordered: false,
        followup: 0,
        totalOrdQuant: 0,
        dollarsOrd: null,
        pointsord: null,
        dollarsOrdTax: null,
        pointsordtax: null,
        invoiceNumber: "",
        dateShipped: "",
        qualityNum: null,
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        supplierId: null,
        city: "",
        state: "",
        zip: "",
        dayphone: "",
        eveningphone: "",
        signature: null,
        message: null,
        email: "",
        certificateNumber: null,
        quantity: 1,
        productId: "",
        productColor: "",
        productSize: "",
        dateProcessed: "",
        backOrderDate: null,
        carrierName: "",
        trackingNumber: "",
        productCost: null,
        productWholeSale: null,
        productShipping: null,
        prodName: "",
        prodNumber: "",
        productsupplier: 0,
        sku: "",
        deleted: null,
        homedeliveryrequired: null,
        psize: "",
        pColor: "",
        userOrderID: null,
        supplierOrderId: null,
        platform: null,
        platformVersion: null,
        clientName: "",
        company: "",
        useCoAddress: "",
        ratio: null,
        productID: null,
        supplierName: null,
        ubspponumber: null,
        upsConfirmationCode: null,
        ubssearsorderid: null,
        uboubsshippingcost: null,
        uboubsShipmethod: null,
        tjOrderdate: null,
        tjOrdernumber: null,
        productgroup: null,
        aaWSOrderid: "",
        aawsamazon_internal_id: "",
        gift_id: null,
        ret_by_name: null,
      },
    ],
    invoices: null,
    CRMNotes: null,
    NoteData: {
      notes_id: null,
      order_id: null,
      supplier_id: null,
      product_id: "",
      user_id: null,
      client_id: null,
      note_date: "",
      title: "",
      content: "",
    },
    extraOrderInfo: null,
  },
  actions: {
    getOrder({ state, commit }, params) {
      return new Promise((resolve, reject) => {
        getOrder(params)
          .then((data) => {
            resolve(data);
            commit("SET_ORDER_DATA", data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getOrder store");
          });
      });
    },
    updateOrderAddress({ commit, state }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        updateOrderAddress(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in updateOrderAddress store");
          });
      });
    },

    updateGiftCard({ commit, state }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        updateGiftCard(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in updateGiftCard store");
          });
      });
    },

    updateOrderStatus({ commit, state }, payload) {
      console.log(payload);
      return new Promise((resolve, reject) => {
        updateOrderStatus(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in updateOrderStatus store");
          });
      });
    },

    updateShipping({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        updateShipping(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in updateShipping store");
          });
      });
    },

    getInvoices({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        getInvoices(params)
          .then((data) => {
            resolve(data);
            commit("SET_INVOICES", data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getInvoices store");
          });
      });
    },

    addInvoice({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        addInvoice(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in addInvoice store");
          });
      });
    },

    deleteInvoice({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        deleteInvoice(params)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in deleteInvoice store");
          });
      });
    },

    updateAll({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        updateAll(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in updateAll store");
          });
      });
    },

    getCRMNotes({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        getCRMNotes(params)
          .then((data) => {
            commit("SET_CRM_NOTES", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getCRMNotes store");
          });
      });
    },

    getCRMNote({ commit, state }, params) {
      console.log(params);
      return new Promise((resolve, reject) => {
        getCRMNote(params)
          .then((data) => {
            commit("SET_NOTE", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getCRMNote store");
          });
      });
    },

    getExtraOrderInfo({ commit, state }, params) {
      return new Promise((resolve, reject) => {
        getExtraOrderInfo(params)
          .then((data) => {
            commit("SET_EXTRA_ORDER_INFO", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in getExtraOrderInfo store");
          });
      });
    },

    addNote({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        addNote(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in addNote store");
          });
      });
    },

    updateNote({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        updateNote(payload)
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "err in updateNote store");
          });
      });
    },
  },
  mutations: {
    SET_ORDER_DATA: (state, data) => {
      let order = data[0];
      if (order.dateShipped) {
        order.dateShipped = UTCToLocale(order.dateShipped);
        order.dateShipped = order.dateShipped.split("Z")[0];
      }
      if (order.labelReqDate) {
        order.labelReqDate = order.labelReqDate.split("T")[0];
      }
      if (order.dateProcessed) {
        order.dateProcessed = order.dateProcessed.split("T")[0];
      }
      if (order.backOrderDate) {
        order.backOrderDate = order.backOrderDate.split("T")[0];
      }
      if (order.ret_reason) {
        order.ret_reason = order.ret_reason.split(":")[1];
      }
      order.callTag = order.callTag ? 1 : 0;
      state.orderData = order;
    },
    SET_INVOICES: (state, data) => {
      state.invoices = data;
    },
    SET_CRM_NOTES: (state, data) => {
      state.CRMNotes = data;
    },
    SET_NOTE: (state, data) => {
      state.NoteData = data;
    },
    SET_EXTRA_ORDER_INFO: (state, data) => {
      data.full_name = `${data.first_name} ${data.last_name}`;
      data.points = data.points.toFixed(4) + " Points";
      state.extraOrderInfo = data;
    },
    SET_LOADING_FOR_STATUS: (state, data) => {
      state.LoadingForStatus = data;
    },
  },
};

export default orderDetails;
